import { useState } from 'react'
import { theme } from '../theme'
import { ModalShell } from './ModalShell'

// Shown before cooking a batch recipe: offer to stash surplus servings as an
// on-hand recipe lot ("cook once, eat twice"). 0 = just cook, no leftovers.
export function LeftoverStashModal({
  open, recipeName, maxServings, onCook, onCancel,
}: {
  open: boolean
  recipeName: string
  maxServings: number
  onCook: (leftoverServings: number) => void
  onCancel: () => void
}) {
  const [val, setVal] = useState('')
  const n = Math.max(0, Math.floor(Number(val) || 0))

  return (
    <ModalShell open={open} onClose={onCancel} zIndex={70} autoHeight
      panelStyle={{ width: 'min(380px, 100%)', padding: '18px 20px', gap: 12 }}>
      <div>
        <div style={{
          fontFamily: theme.sans, fontSize: 10, letterSpacing: 1.4, fontWeight: 600,
          textTransform: 'uppercase', color: theme.muted,
        }}>Cook · {recipeName}</div>
        <div style={{
          fontFamily: theme.serif, fontSize: 20, fontWeight: theme.headWeight,
          color: theme.ink, marginTop: 2,
        }}>Save any leftovers?</div>
      </div>

      <div style={{ fontFamily: theme.sans, fontSize: 13, color: theme.inkSoft, lineHeight: 1.4 }}>
        This recipe makes {maxServings} servings. Stash the surplus as an on-hand
        lot you can schedule as a leftover later. Leave blank for none.
      </div>

      <label style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
        <span style={{
          fontFamily: theme.sans, fontSize: 10, letterSpacing: 1, fontWeight: 600,
          textTransform: 'uppercase', color: theme.muted,
        }}>Leftover servings</span>
        <input type="number" inputMode="numeric" min="0" step="1" placeholder="0"
          value={val} onChange={e => setVal(e.target.value)} autoFocus
          style={{
            all: 'unset', boxSizing: 'border-box', width: '100%',
            padding: '7px 10px', borderRadius: theme.radius,
            border: `1px solid ${theme.lineStrong}`, background: theme.bg,
            fontFamily: theme.sans, fontSize: 13, color: theme.ink,
          }}/>
      </label>

      <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 4 }}>
        <button onClick={onCancel} style={btnSecondary}>Cancel</button>
        <button onClick={() => onCook(n)} style={btnPrimary}>
          {n > 0 ? `Cook + save ${n}` : 'Cook'}
        </button>
      </div>
    </ModalShell>
  )
}

const btnSecondary: React.CSSProperties = {
  all: 'unset', cursor: 'pointer',
  padding: '8px 14px', borderRadius: theme.radius,
  fontFamily: theme.sans, fontSize: 12, fontWeight: 600, letterSpacing: 0.4,
  textTransform: 'uppercase', color: theme.ink,
  border: `1px solid ${theme.lineStrong}`,
}
const btnPrimary: React.CSSProperties = {
  all: 'unset', cursor: 'pointer',
  padding: '8px 14px', borderRadius: theme.radius,
  fontFamily: theme.sans, fontSize: 12, fontWeight: 700, letterSpacing: 0.4,
  textTransform: 'uppercase', color: theme.surface, background: theme.ink,
}
